export * from "./CommunityRegistry.abi";
export * from "./DITOCommunity.abi";
export * from "./PartnersAgreement.abi";
export * from "./PartnersRegistry.abi";
export * from "./SkillWallet.abi";
export * from "./Gigs.abi";
export * from "./Olympics.abi";
export * from "./Competitions.abi";
export * from "./Checkpoints.abi";
export * from "./Activities.abi";
export * from "./SkillWalletCommunity.abi";
